import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=34ea905e&scoped=true&"
import script from "./LoadingButton.vue?vue&type=script&lang=js&"
export * from "./LoadingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea905e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ea905e')) {
      api.createRecord('34ea905e', component.options)
    } else {
      api.reload('34ea905e', component.options)
    }
    module.hot.accept("./LoadingButton.vue?vue&type=template&id=34ea905e&scoped=true&", function () {
      api.rerender('34ea905e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_Buttons/LoadingButton.vue"
export default component.exports